import React, { useEffect } from 'react';
import { Grid, TextField, Typography } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { useState } from 'react';
import { LocalizationProvider } from '@mui/x-date-pickers';
import DateFnsUtils from '@date-io/date-fns';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { es } from 'date-fns/locale';
import { handleError, handleSuccess } from '../../helpers/utils';
import { Stack } from '@mui/system';
import { useNavigate, useParams } from 'react-router';
import { getAreaInfo, registerArea, updateArea } from '../../actions/areas';

export const AreasForm = ({ edit = false }) => {
	// URL params
	const { idArea = null } = useParams();

	// Define state to know if it's loading or not
	const [isLoading, setIsLoading] = useState(false);

	// Form
	const [name, setName] = useState('');
	const [days, setDays] = useState('');

	// Path
	const path = '/dashboard/areas';

	// Navigation
	const navigate = useNavigate();

	// Handle submit
	const handleSubmit = () => {
		setIsLoading(true);

		const formData = {
			name,
			days: parseFloat(days),
		};

		if (edit) {
			updateArea(idArea, formData)
				.then(() => {
					handleSuccess('Área actualizada correctamente.');
					localStorage.setItem('lastPathPilu', path);
					navigate(path);
				})
				.catch((error) => {
					handleError(error, 'No se pudo actualizar la área.');
				});
		} else {
			registerArea(formData)
				.then(() => {
					handleSuccess('Área agregada correctamente.');
					localStorage.setItem('lastPathPilu', path);
					navigate(path);
				})
				.catch((error) => {
					handleError(error, 'No se pudo agregar la área.');
				});
		}
		setIsLoading(false);
	};

	useEffect(() => {
		if (edit) {
			getAreaInfo(idArea).then(({ data }) => {
				setName(data ? data.name : '');
				setDays(data ? data.days : '');
			});
		}
	}, []);

	return (
		<div style={{ padding: '25px' }}>
			<LocalizationProvider
				dateAdapter={AdapterDateFns}
				adapterLocale={es}
				utils={DateFnsUtils}
			>
				<Stack
					direction='column'
					alignItems='flex-start'
					justifyContent='space-between'
					style={{
						border: '1px solid white',
						padding: '20px 20px 0 0',
						margin: '0 0 10px 0',
						width: '100%',
					}}
				>
					<Typography variant='h4' gutterBottom>
						Áreas
					</Typography>
					<Typography variant='p' gutterBottom>
						Complete el formulario para{' '}
						{edit ? 'editar la' : 'crear una nueva'} área
					</Typography>
				</Stack>
				<hr />
				<Grid container spacing={2} className='mt-2'>
					<Grid item xs={6}>
						<TextField
							required
							fullWidth
							value={name}
							onChange={({ target }) => setName(target.value)}
							label='Nombre'
						/>
					</Grid>

					<Grid item xs={6}>
						<TextField
							required
							fullWidth
							type='number'
							value={days}
							onChange={({ target }) => setDays(target.value)}
							label='Días'
						/>
					</Grid>

					<Grid item xs={6}>
						<LoadingButton
							fullWidth
							size='large'
							color='error'
							onClick={() => {
								localStorage.setItem('lastPathPilu', path);
								navigate(path);
							}}
							variant='contained'
							loading={false}
						>
							Cancelar
						</LoadingButton>
					</Grid>

					<Grid item xs={6}>
						<LoadingButton
							fullWidth
							size='large'
							type='submit'
							variant='contained'
							loading={isLoading}
							style={{ backgroundColor: '#143f6c' }}
							onClick={handleSubmit}
						>
							{edit ? 'Actualizar' : 'Guardar'}
						</LoadingButton>
					</Grid>
				</Grid>
			</LocalizationProvider>
		</div>
	);
};
